import { RootState } from '@spa/lib/store/RootState';

const selectPathname = (state: RootState): string => {
  return state.router.pathname;
};

export default selectPathname;
